import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/BonusCardRequest/bonusCardRequest.container"
    ).then((module) => ({ default: module.BonusCardRequestContainer }))
);
